// Using react-relay 1.4.1, having this fragment and using @relay(mask: false) prevented
// variables from being passed down. Manually unmasking here is the interim solution
// TODO: REMOVE THIS when bumping relay

import { getSelector } from 'relay-runtime'; // To fix mask issue. See usage below

export const unmaskFragmentData = ({
    relayContext,
    relayEnvironment,
    relayVariables,
    relayData,
    fragmentPropName,
    fragment,
}) => {
    if (!relayData) {
        return null;
    }
    const fragmentFunc = fragment[fragmentPropName];
    let selector;

    if (relayContext) {
        selector = getSelector(relayContext.variables, fragmentFunc(), relayData);
        return relayContext.environment.lookup(selector).data;
    } else {
        selector = getSelector(relayVariables, fragmentFunc(), relayData);
        return relayEnvironment.lookup(selector).data;
    }
};
